module.exports = __webpack_public_path__ + "prod/20260406190927/img/service.edbff227.png";